export const dataHooks = {
  input: 'list-item-editable-input',
  approveButton: 'list-item-editable-approve-button',
  cancelButton: 'list-item-editable-cancel-button',
  approveButtonTooltip: 'list-item-editable-approve-button-tooltip',
  cancelButtonTooltip: 'list-item-editable-cancel-button-tooltip',
};
